import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/index.css';
import Brand from '../components/Brand';
import SEO from '../components/SEO';

const Industries: React.FC = () => {
  const navigate = useNavigate();
  const goToDemo = () => navigate('/request-demo');

  return (
    <div className="home-container">
      <SEO
        title="Industries We Serve — Healthcare, Procurement & SMB Operations"
        description="OpenUse serves healthcare, dental, procurement, and warehouse-driven SMB teams with mobile-first inventory and sourcing software."
        path="/industries"
      />
      <div className="hero-section solutions-hero">
        <div className="hero-content">
          <p className="hero-eyebrow">Industries</p>
          <h1 className="hero-headline">
            Built for the teams that keep operations moving.
          </h1>
          <p>
            <Brand /> serves operations leaders across regulated, high-stakes
            industries — where missing a supply, mis-awarding a bid, or losing
            count of inventory has real consequences.
          </p>
        </div>
      </div>

      <section className="solutions-section">
        <h2 className="section-title">Who we serve</h2>

        <div className="services-grid industries-grid">
          <div className="card industry-card">
            <h3>Healthcare &amp; Dental</h3>
            <p className="industry-roles">
              Hospital supply chain leaders, dental office owners, and clinic operators.
            </p>
            <p>
              Track every consumable, instrument, and implant by lot and
              expiration. Eliminate stock-outs in clinical spaces and
              strengthen audit posture with point-of-use capture.
            </p>
            <Link to="/product/supplymd" className="product-card-link">
              Explore SupplyMD &rsaquo;
            </Link>
          </div>

          <div className="card industry-card">
            <h3>Procurement &amp; Sourcing</h3>
            <p className="industry-roles">
              Procurement managers and sourcing teams in mid-market and enterprise.
            </p>
            <p>
              Replace email-and-spreadsheet RFQs with structured bidding,
              scored responses, and a defensible award trail — across every
              category and business unit.
            </p>
            <Link to="/product/openrfq" className="product-card-link">
              Explore OpenRFQ &rsaquo;
            </Link>
          </div>

          <div className="card industry-card">
            <h3>Warehouse-driven SMB</h3>
            <p className="industry-roles">
              Small and midsize businesses operating a warehouse or stockroom.
            </p>
            <p>
              Layer AI-driven forecasting, anomaly detection, and reorder
              automation on top of your existing inventory data — without
              ripping out your ERP.
            </p>
            <Link to="/product/ainventory" className="product-card-link">
              Explore AInventory &rsaquo;
            </Link>
          </div>

          <div className="card industry-card">
            <h3>Facilities, Field &amp; IT Operations</h3>
            <p className="industry-roles">
              Facilities managers, field service crews, IT teams, and asset-heavy operators.
            </p>
            <p>
              Track tools, equipment, IT devices, and leased assets across
              locations with barcode scanning, mobile check-in/check-out, and
              audit-ready history — straight from an iPhone or iPad.
            </p>
            <Link to="/product/atracker" className="product-card-link">
              Explore ATracker &rsaquo;
            </Link>
          </div>
        </div>

        <div className="solutions-cta-row">
          <button className="hero-cta primary" onClick={goToDemo}>Talk to sales</button>
        </div>
      </section>
    </div>
  );
};

export default Industries;
